import { jsx } from "react/jsx-runtime";
import { c as clsx } from "../../../chunks/clsx-DgYk2OaC.js";
import { h as helpers } from "../../../chunks/helpers.module-CuLQagYQ.js";
const spinner = "_spinner_qof2f_3";
const rotation = "_rotation_qof2f_1";
const spinnerColor = "_spinnerColor_qof2f_13";
const styles = {
  spinner,
  rotation,
  spinnerColor,
  "spinner-small": "_spinner-small_qof2f_20",
  "spinner-large": "_spinner-large_qof2f_26",
  "fade-in": "_fade-in_qof2f_1",
  "fade-out": "_fade-out_qof2f_1",
  "shrink-width": "_shrink-width_qof2f_1",
  "slide-in-up": "_slide-in-up_qof2f_1",
  "slide-out-down": "_slide-out-down_qof2f_1",
  "appear-from-bottom": "_appear-from-bottom_qof2f_1",
  "disappear-to-bottom": "_disappear-to-bottom_qof2f_1"
};
const Spinner = ({
  size = "large",
  status,
  description,
  className,
  ...props
}) => /* @__PURE__ */ jsx(
  "span",
  {
    className: clsx(styles.spinner, styles.spinnerColor, styles["spinner-" + size], className),
    role: status ? "status" : void 0,
    ...props,
    children: description && /* @__PURE__ */ jsx("span", { className: helpers.srOnly, children: description })
  }
);
export {
  Spinner
};
